import ListItem from "@material-ui/core/ListItem/ListItem";
import React, { FC, memo, ReactElement } from "react";
import { useSelector } from "react-redux";

import { PROFILE } from "../../constants/path-constants";
import { DEFAULT_PROFILE_IMG } from "../../constants/url-constants";
import { HoverItemDetail, useHoverItem } from "../../hook/useHoverItem";
import { selectUserDataId } from "../../store/ducks/user/selectors";
import { fetchUserDetail } from "../../store/ducks/userDetail/actionCreators";
import { UserResponse } from "../../types/user";
import LinkWrapper from "../LinkWrapper/LinkWrapper";
import PopperUserWindow from "../PopperUserWindow/PopperUserWindow";
import BlockButton from "./BlockButton/BlockButton";
import FollowButton from "./FollowButton/FollowButton";
import PendingButton from "./PendingButton/PendingButton";
import UnfollowButton from "./UnfollowButton/UnfollowButton";
import UserItemAvatar from "./UserItemAvatar/UserItemAvatar";
import UserItemInfo from "./UserItemInfo/UserItemInfo";
import { useUsersItemStyles } from "./UsersItemStyles";
import { useUserFollow } from "../../context/UserFollowContext";

export interface UsersItemProps {
    user?: UserResponse,
    size?: UserItemSize
}

export enum UserItemSize {
    SMALL = "SMALL",
    MEDIUM = "MEDIUM",
    LARGE = "LARGE",
}

const UsersItem: FC<UsersItemProps> = memo(({ user, size }): ReactElement => {
    const classes = useUsersItemStyles({ size });
    const myProfileId = useSelector(selectUserDataId);
    const { followRecord } = useUserFollow();
    const { visiblePopperWindow, handleHoverPopper, handleLeavePopper } = useHoverItem(fetchUserDetail);
    const isNotFollow = followRecord[user?.id || '']?.isFollow === undefined ? false : !followRecord[user?.id || '']?.isFollow
    return (
        <LinkWrapper path={`${PROFILE}/${user?.id}`} visiblePopperWindow={visiblePopperWindow}>
            <ListItem className={classes.container}>
                <div
                    id={"userInfo"}
                    className={classes.userInfo}
                    onMouseEnter={() => handleHoverPopper({ userId: user?.id } as HoverItemDetail)}
                    onMouseLeave={handleLeavePopper}
                >
                    <UserItemAvatar avatar={user?.avatar ?? DEFAULT_PROFILE_IMG} />
                    <div className={classes.userInfoDetails}>
                        <UserItemInfo
                            fullName={user?.fullName}
                            username={user?.username}
                            about={user?.about}
                            isPrivateProfile={user?.isPrivateProfile}
                            isMyProfileBlocked={user?.isMyProfileBlocked}
                            size={size}
                        />
                    </div>
                    <PopperUserWindow visible={visiblePopperWindow} />
                </div>
                <div className={classes.buttonWrapper}>
                    {(myProfileId === user?.id) ? null : (
                        (user?.isMyProfileBlocked) ? null : (
                            (!user?.isFollowing || isNotFollow) ? (
                                (user?.isUserBlocked) ? (
                                    <BlockButton user={user} />
                                ) : (
                                    (user?.isWaitingForApprove) ? (
                                        <PendingButton user={user} />
                                    ) : (
                                        <FollowButton user={user} />
                                    )
                                )
                            ) : (
                                <UnfollowButton user={user} />
                            )
                        )
                    )}
                </div>
            </ListItem>
        </LinkWrapper>
    );
});

export default UsersItem;
